import { render, staticRenderFns } from "./ScraperDetail.vue?vue&type=template&id=838cfb70&"
import script from "./ScraperDetail.vue?vue&type=script&lang=js&"
export * from "./ScraperDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports